exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".feature-card-section-container {\n  display: flex;\n  flex-direction: row;\n  padding: 3.75rem 9.375rem;\n}\n@media only screen and (max-width: 30rem) {\n  .feature-card-section-container {\n    padding: 3.75rem 2.5rem;\n  }\n}\n", ""]);

